import { createContext, useContext, useReducer, useEffect, useState } from "react";
import { reducer, initialState } from "./GameReducer.js";

const GameContext = createContext(null);

export function GameProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [modalPlayer, setModalPlayer] = useState(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem("ww_players");
      if (raw) dispatch({ type: "LOAD_PLAYERS", payload: JSON.parse(raw) });
    } catch {}
    try {
      const rawS = localStorage.getItem("ww_settings");
      if (rawS) dispatch({ type: "LOAD_SETTINGS", payload: JSON.parse(rawS) });
    } catch {}
    try {
      const rawA = localStorage.getItem("ww_last_active");
      if (rawA) dispatch({ type: "LOAD_LAST_ACTIVE", payload: JSON.parse(rawA) });
    } catch {}
  }, []);

  return (
    <GameContext.Provider value={{ state, dispatch, modalPlayer, setModalPlayer }}>
      {children}
    </GameContext.Provider>
  );
}

export function useGame() { return useContext(GameContext); }
export function useModal() {
  const { modalPlayer, setModalPlayer } = useContext(GameContext);
  return { modalPlayer, setModalPlayer };
}
